import { FlexibleTextBlockProps } from '../../components/FlexibleTextBlock';
import { TextBoxProps } from '../../components/privatleasing/TextBox';

export const heroPrivatLeasing = {
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range.jpg',
  mobileImage:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range_mobile.jpg',
};

export const subHeadingOne = {
  text: 'Populära leasingerbjudanden',
};

export const subHeadingTwo = {
  text: 'Bilmodeller att leasa',
};

export const textBox = {
  title: 'Privatleasa en laddbar bil från Kia med 0 kr i kontantinsats.',
  body: 'Kia Privatleasing är ett enkelt och bekvämt sätt att finansiera din Kia. Privatleasa en laddbar Kia med 0 kr i kontantinsats och kostnadsfritt Kia Privatleasingskydd i tre månader. Dessutom ingår alltid vägassistans, 7 års nybilsgaranti från fabrik och Kia Serviceavtal.',
  backgroundColor: '',
  numberOfFields: 3,
  titleStyle:
    'text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-6 max-w-[627px]',
  textSize: 'text-lg leading-[24px]',
};

export const contentTextBoxAndIcons = {
  titleLine1: 'Privatleasing',
  titleLine2: 'Det här ingår när du leasar bil:',
  backgroundColor: '#37434C',
  titleColor: '#FFFFFF',
  textColor: '#FFFFFF',
  listItems: [
    {
      text: '0 kr i kontantinsats',
      iconProps: { color: '#FFFFFF', width: 25, height: 25, strokeWidth: 4 },
    },
    {
      text: 'Kia Serviceavtal',
      iconProps: { color: '#FFFFFF', width: 25, height: 25, strokeWidth: 4 },
    },
    {
      text: '7 års nybilsgaranti',
      iconProps: { color: '#FFFFFF', width: 25, height: 25, strokeWidth: 4 },
    },
    {
      text: 'Vägassistans',
      iconProps: { color: '#FFFFFF', width: 25, height: 25, strokeWidth: 4 },
    },
    {
      text: 'Kia Privatleasingskydd i 3 månader',
      iconProps: { color: '#FFFFFF', width: 25, height: 25, strokeWidth: 4 },
    },
  ],
};

export const popularLeasing = {
  backgroundColor: '',
  numberOfFields: 3,
  mtClass: 'mt-4',
  mbClass: 'mb-9',
  titleStyle:
    'text-center text-black p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-6 max-w-[627px]',
  textSize: 'text-lg leading-[24px]',
  listItems: [
    {
      text: 'Kia Privatleasing är ett enkelt och bekvämt sätt att finansiera din Kia.',
      boldParts: ['finansiera din Kia'],

      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Privatleasa en elbil eller laddbar Kia med 0 kr i kontantinsats och kostnadsfritt Kia Privatleasingskydd i tre månader.',
      boldParts: ['kostnadsfritt Kia Privateleasingskydd'],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Dessutom ingår alltid vägassistans, 7års nybilsgaranti från fabrik och Kia serviceavtal.',
      boldParts: ['Dessutom ingår alltid vägassistans,'],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
  ],
} satisfies TextBoxProps;

export const electricCarLeasing = {
  title: 'Leasa elbil',
  text: 'Kia erbjuder flera elbilsmodeller för privatleasing: bland annat den stora el-SUV:en Kia EV9, den sportiga el-crossovern Kia EV6, prestandaelbilen Kia EV6 GT och den kompakta el-SUV:en Kia EV3.',
  links: [
    {
      url: 'https://www.kia.com/se/elbil/elbil/',
      text: 'Läs mer om våra elbilar.',
    },
    {
      url: 'https://www.kia.com/se/elbil/laddhybrid/',
      text: 'Se även våra laddhybrider.',
    },
  ],
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Ev6-FL-2024-Dec.jpg',
    alt: 'En grå Kia EV6 kör på en bro i skymningen.',
  },
};

export const leasingGettingStarted = {
  title: 'Vad är privatleasing?',
  text: 'Kia Privatleasing är ett enkelt och bekymmersfritt finansieringsalternativ som kan beskrivas som långtidshyra av en bil. Allt fler tycker att det är viktigare att köra en ny bil än att äga den och väljer därför privatleasing som finansieringsalternativ.',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder2.png',
    alt: 'Man med surfbräda vid en Kia parkerad på en grusväg i en barrskog.',
  },
};

export const kiaPrivatleasingskyddBlock = {
  content: [
    {
      __type: 'heading',
      content: 'Kia Privatleasingskydd',
    },
    {
      __type: 'text',
      content:
        'Kia Privatleasingskydd är en försäkring som betalar kundens privatleasingavtal i upp till ett år om han eller hon blir sjuk eller arbetslös:',
    },
    {
      __type: 'list',
      items: [
        'Sjukskrivning i mer än 30 dagar - skydd för kunden som är anställd eller egenföretagare.',
        'Ofrivillig arbetslöshet i mer än 30 dagar – skydd för kunden som är anställd eller egenföretagare.',
        'Dödsfall – vid dödsfall ersätts kundens utestående månadsbetalningar för privatleasingavtalet.',
      ],
    },
    {
      __type: 'text',
      content:
        'Premien är 6,5% och beräknas på månadshyran exkl. service, försäkring och avgifter. Försäkringspremien redovisas separat på fakturan.',
    },
    {
      __type: 'link',
      links: [
        {
          url: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/privatleasing/Privatleasingsskydd_A4.pdf',
          label: 'Ladda ner informationsblad',
        },
      ],
    },
  ],
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder3.png',
    alt: 'Ett ungt par sitter och äter framför ett upplyst tält på en strand i skymningen, med en campinglampa mellan sig.',
  },
} satisfies FlexibleTextBlockProps;

export const getStarted = {
  title: 'Så fungerar privatleasing',
};

export const gettingStarted = {
  content: [
    {
      __type: 'heading',
      content: '1. Välj bil att leasea.',
    },
    {
      __type: 'text',
      content:
        'Välj en bil som passar dina behov. Idag har vi 10 olika laddbara modeller att välja mellan. Med en laddbar Kia kan du alltid räkna med integrerad telematik, adaptiv farthållare, eluppvärmd ratt och uttrycksfulla metallic-färger.',
      className: 'mb-6',
    },
    {
      __type: 'heading',
      content: '2. Besök din återförsäljare',
    },
    {
      __type: 'text',
      content:
        'När du har bestämt dig för en bilmodell eller om du vill provköra en Kia, kontakta din närmaste Kia-återförsäljare.',
    },
    {
      __type: 'link',
      links: [
        {
          url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
          label: 'Hitta återförsäljare',
        },
      ],
    },
  ],
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder1.png',
    alt: 'En modern, ljust inredd utställningsmonter för Kia, med träpaneler, ett vitt bord och trästolar, samt en skärm som visar en bil.r',
  },
} satisfies FlexibleTextBlockProps;

export const leasingAltenative = {
  title: 'Alternativ till leasing',
  text: 'Vill du istället äga din bil erbjuder Kia flexibla och skräddarsydda billån inklusive Kia serviceavtal. Läs mer om våra övriga finanseringsalternativ.',
  links: [
    {
      text: 'Läs om Kia Billån',
      url: 'https://www.kia.com/se/kopa/billan/#/',
      className: 'border-2 border-black h-12',
      openInNewTab: false,
      textColor: 'black',
      bgColor: 'white',
    },
    {
      text: 'Se prislista',
      url: 'https://www.kia.com/se/kopa/prislista/',
      className: 'w-[298px] h-12',
      openInNewTab: false,
    },
  ],
  gap: '5',
  titleFontSize: 'text-[32px] md:text-[32px]',
  textFontSize: 'text-[16px] md:text[18px] font-light',
};

export const companyLeasing = {
  content: [
    {
      __type: 'heading',
      content: 'Företagsleasing',
    },
    {
      __type: 'text',
      content:
        'Med Kia Business Lease för ert företag kan ni uppleva laddbar frihet i form av en välutrustad laddbar Kia inklusive försäkring, service, vinterhjul och med garanterat restvärde.⁵',
    },
    {
      __type: 'link',
      links: [
        {
          url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
          label: 'Läs mer om Business lease',
        },
      ],
    },
  ],
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder4.png',
    alt: 'Tre Kia elbilar – en ljus SUV (vänster), en grå crossover (mitten) och en blå SUV (höger) – står parkerade utomhus på en asfalterad yta under klarblå himmel.',
  },
} satisfies FlexibleTextBlockProps;
export const faqBlockPL = {
  title: 'Vanliga frågor om privatleasing',
  questions: [
    {
      q: 'Behöver jag betala kontantinsats vid privatleasing?',
      a: 'Nej, vid privatleasing finns inget krav på kontantinsats.',
    },
    {
      q: 'Vad krävs för att bli godkänd för Kia Privatleasing?',
      a: 'Våra krav är att leasingtagaren har giltigt körkort (vid utländskt körkort krävs komplettering med svensk ID handling) och blir godkänd vid sedvanlig kreditprövning.',
    },
    {
      q: 'Är månadskostnaden fast?',
      a: 'Nej, månadskostnaden baseras på en rörlig ränta och kan ändras beroende på ränteutvecklingen.',
    },
    {
      q: 'Om jag kör mer än avtalad körsträcka?',
      a: 'För dig som privatleasingkund görs det vid återlämnandet en kontroll av bilens skick. Då kontrolleras även att service har utförts enl. service- och garantihandboken. Det sker en avräkning och övermilen debiteras enligt avtal.',
    },
    {
      q: 'Kan jag ändra avtalade mil på mitt leasingavtal?',
      a: 'Det går endast att ändra miltal innan leverans av bil, du kan inte ändra miltal när avtalet påbörjats.',
    },
    {
      q: 'Om jag önskar köpa tillbehör till min bil?',
      a: 'Om du önskar köpa tillbehör tala med din Kia-återförsäljare så hjälper de gärna dig.',
    },
    {
      q: 'Ingår bilförsäkring?',
      a: 'I månadsbetalningen ingår inte bilförsäkring. Du kan enkelt välja till en Kia Bilförsäkring till en förmånlig månadskostnad. Din återförsäljare hjälper dig gärna med att lägga upp detta vid leverans.',
    },
    {
      q: 'Behöver jag ha en försäkring på min privatleasade bil?',
      a: 'Ja, ett fordon som finansieras via Kia Finans måste alltid vara helförsäkrat. Så länge bilen har vagnskadegaranti räcker det med en halvförsäkring. Du väljer själv om du önskar ha en Kia Bilförsäkring som samfaktureras via Kia Finans eller ett annat försäkringsbolag. Läs mer om <a href="https://www.kiabilforsakring.com/" target="_blank">Kia Bilförsäkring.</a>',
    },
    {
      q: 'Om jag får skador på bilen vad händer då?',
      a: 'Det är viktigt att du tar hand om din privatleasade Kia under hela avtalsperioden för att inte råka ut för onödiga kostnader när du ska lämna tillbaka ditt fordon. Det första som görs när du lämnar tillbaka din bil är en skadebesiktning av en auktoriserad Kia-återförsäljare. Slitage som anses vara normalt debiteras inte. Slitage som däremot anses vara onormalt påverkar bilens värde och kommer därför att debiteras enligt det testprotokoll som upprättats. För att läsa mer om vad som anses som onormalt slitage läs <a href="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/finance-a-purchase/privatleasing/kia_underhall_och_aterlamningsguide.pdf" target="_blank">Kias återlämningsguide.</a>',
    },
    {
      q: 'Vad ingår i ett serviceavtal?',
      a: 'Vi på Kia tycker det är viktigt att serva bilen så att du som kund ska känna dig säker och trygg med din nya privatleasade Kia. Det är även viktigt för att bibehålla nybilsgarantin att service görs enligt bilens serviceintervall. Serviceavtalet ingår i priset på din privatleasing och innefattar alla de punkter som våra fabriker/ ingenjörer har konstaterat att man behöver kontrollera för att bilen ska må bra samt bibehålla den goda kvalitet som Kia står för. Det ingår även förlängd assistans när du servar din privatleasade bil hos en auktoriserad Kia-verkstad. Värdet för servicen specificeras separat i ditt avtal och på dina kommande fakturor och gäller endast hos auktoriserad Kia-verkstad.',
    },
    {
      q: 'När ska jag serva bilen?',
      a: 'Bilen ska servas i enlighet med bilens serviceplan. Det är viktigt att samtliga servicar har utförts på fordonet enligt service- och garantiboken. Om service inte är gjord i enlighet med detta kommer en värdeminskningskostnad debiteras vid återlämnandet på 20.000 sek inkl. moms. Vid återlämnandet sker en kontroll av bilens skick och att service har utförts enligt service- och garantihandboken. Dessutom görs en avräkning och eventuella övermil debiteras enligt avtal.',
    },
    {
      q: 'Hur bokar jag service?',
      a: 'All bokning av service sker via auktoriserade Kia-verkstäder. Hitta din närmaste auktoriserade verkstad <a href="https://www.kia.com/se/sok-aterforsaljare-verkstad" target="_blank">här</a>. Eller boka direkt online via <a href="https://www.kia.com/se/guestbooking/new-appointment/" target="_blank">denna länk.</a>',
    },
    {
      q: 'Kan jag överlåta mitt privatleasingavtal?',
      a: 'Nej, det är inte möjligt att överlåta ditt privatleasingavtal.',
    },
    {
      q: 'Kan jag förlänga mitt privatleasingavtal?',
      a: 'Nej, du kan inte förlänga ditt avtal utan ska återlämna bilen vid kontraktstidens slut.',
    },
    {
      q: 'Mitt privatleasingavtal på väg att löpa ut, vad gör jag?',
      a: 'Vi ber dig kontakta den Kia-återförsäljare som levererade bilen för planering av genomgång och återlämnande av fordonet. Om du trivs med upplägget kan du hämta ut en helt ny Kia och påbörja en ny treårig leasingperiod. Läs <a href="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/finance-a-purchase/privatleasing/kia_underhall_och_aterlamningsguide.pdf" target="_blank">Kias återlämningsguide här.</a>',
    },
  ],
};

export const navLinksPL = {
  links: [
    { text: 'Leasingerbjudanden', link: '#leasing-offer' },
    { text: 'Bilmodeller att leasa', link: '#popular-models' },
    { text: 'Så fungerar leasing', link: '#how-it-works' },
    { text: 'Leasa elbil', link: '#leasing' },
    { text: 'Frågor & Svar', link: '#faq' },
    {
      text: 'Kontakta Återförsäljare',
      link: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
    },
    { text: 'Provkör Kia', link: 'https://www.kia.com/se/provkor/#/' },
  ],
};

export const kiaImageOne = {
  src: 'https://kia-afonso-storage.b-cdn.net/Appsida-bild-ev3.jpg',
  alt: 'En kvinna i ljusa kläder sitter och vilar i solskenet mot en betongvägg, bredvid bakdelen på en parkerad ljusgrön Kia EV3 SUV med klippor i bakgrunden.',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'lg:min-h-[550px] max-h-[600px] object-cover object-center',
};
